require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-senior-vice-president-of-internal-audit.json") })
        }
      }, "path---es-articles-tags-senior-vice-president-of-internal-audit");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-senior-vice-president-of-internal-audit!./.cache/json/es-articles-tags-senior-vice-president-of-internal-audit.json
// module id = 2447
// module chunks = 231608221292675